import ActionBar from "../actionBar.component";
import CreateOrderedPartButton from "../../buttons/parts/createOrderedPart.part.button";
import FetchRSVendorsButton from "../../buttons/vendor/fetchRSVendors.vendor.button.component";
import { SelectedOpenPartOrdersContext } from "../../../contexts/parts/selectedOpenPartOrders.part.context";
import { useContext, useState } from "react";
import DefaultButton from "../../buttons/default.button";
import { OpenPartOrdersContext } from "../../../contexts/parts/openPartOrders.context";
import CreateOpenPartButton from "../../buttons/parts/createOpenPart.part.button";

const DELETE_BUTTON_CLASSNAMES = {
  button:
    "bg-red-500 hover:bg-red-700 shadow active:skew-y-0 hover:skew-y-3 shadow-secondary font-ubuntuBold rounded px-4 py-2 text-white",
};

const OpenPartOrdersActionBar = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { deletePartOrders, loading, fetchPartOrders } = useContext(
    OpenPartOrdersContext
  );
  const { selectedOpenPartOrders, resetSelectedOpenPartOrders } = useContext(
    SelectedOpenPartOrdersContext
  );
  const handleDeleteManyPartOrders = () => {
    if (isLoading) return;
    setIsLoading(true);
    if (selectedOpenPartOrders.length === 0) return;
    deletePartOrders(selectedOpenPartOrders);
    resetSelectedOpenPartOrders();
    setIsLoading(false);
  };
  return (
    <ActionBar>
      {selectedOpenPartOrders.length > 0 && (
        <DefaultButton
          classNames={DELETE_BUTTON_CLASSNAMES}
          handleClick={handleDeleteManyPartOrders}
          loading={loading}
        >
          Delete {selectedOpenPartOrders.length}
        </DefaultButton>
      )}
      <FetchRSVendorsButton />
      <CreateOrderedPartButton onClose={fetchPartOrders} />
      {children}
    </ActionBar>
  );
};

export default OpenPartOrdersActionBar;
